import { Tabs } from 'antd';
import React from 'react';
import { CONFIG_TOY_TABS } from '../../../../../common/constants';

const TAB_ENTRIES = [
  CONFIG_TOY_TABS?.AVAILABILITY,
  CONFIG_TOY_TABS?.RANKING,
  CONFIG_TOY_TABS?.RESERVATION_RULES,
];

const ConfigToyTabs = ({ activeKey, onChange, children }) => {
  const items = TAB_ENTRIES.map((tab) => ({
    key: tab.key,
    label: tab.label,
    children: activeKey === tab.key ? children : null,
  }));

  return (
    <div className="card-container">
      <Tabs
        activeKey={activeKey}
        type="card"
        className="full-width"
        onChange={onChange}
        items={items}
        destroyInactiveTabPane
      />
    </div>
  );
};

export default ConfigToyTabs;
